[{"display_name":"Bogotá","location_slug":"colombia--bogotá--366339"}]